module.exports = __webpack_public_path__ + "static/media/LoginScreen.1944ef10.png";